import { Skeleton } from '@mui/material';
import React from 'react';

import SmallForm from './small-form';

import Arranger from '~c/components/base/arranger';
import Spacer, { spc } from '~c/components/base/spacer';

interface Props {
  className?: string;
}

/**
 * SignUpSkeleton is a loading skeleton component that shows while
 * the application is initializing and JavaScript is loading.
 *
 * It mimics the structure of the actual sign-up form to provide
 * visual feedback during the loading state.
 */
const SignUpSkeleton: React.FC<Props> = ({ className }) => {
  return (
    <SmallForm
      className={className}
      title={
        <Arranger direction="column" alignItems="center">
          <Skeleton variant="rectangular" width={150} height={50} />
          <Skeleton
            variant="text"
            width={150}
            height={40}
            sx={{ mt: spc.xs }}
          />
        </Arranger>
      }
    >
      <Arranger direction="column">
        {/* Email field skeleton */}
        <Skeleton variant="rectangular" width="100%" height={56} />
        <Spacer mb={spc.between_vertical_s} />

        {/* Password field skeleton */}
        <Skeleton variant="rectangular" width="100%" height={56} />
        <Spacer mb={spc.between_vertical_s} />

        {/* First name field skeleton */}
        <Skeleton variant="rectangular" width="100%" height={56} />
        <Spacer mb={spc.between_vertical_s} />

        {/* Last name field skeleton */}
        <Skeleton variant="rectangular" width="100%" height={56} />
        <Spacer mb={spc.between_vertical_s} />

        {/* Job title field skeleton */}
        <Skeleton variant="rectangular" width="100%" height={56} />

        <Spacer mb={spc.xl} />

        {/* Submit button skeleton */}
        <Skeleton variant="rounded" width="100%" height={48} />

        <Spacer mb={spc.l} />

        {/* Links skeleton */}
        <Arranger direction="column" alignItems="center">
          <Skeleton variant="text" width={200} height={20} />
          <Spacer mb={spc.xs} />
          <Skeleton variant="text" width={180} height={20} />
        </Arranger>
      </Arranger>
    </SmallForm>
  );
};

export default SignUpSkeleton;
